import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import { checkUserAccess } from '../utils/userAccess';
import './AccessDenied.css';

const AccessDenied = () => {
  const navigate = useNavigate();
  const { user, logout } = useApp();
  const [isLoading, setIsLoading] = useState(false);
  const [showContactInfo, setShowContactInfo] = useState(false);

  useEffect(() => {
    if (!user) {
      navigate('/login');
      return;
    }

    const access = checkUserAccess(user);
    
    if (access.shouldShowPending) {
      navigate('/approval-pending');
      return;
    }

    if (access.hasAccess) {
      navigate('/dashboard');
      return;
    }
  }, [user, navigate]);

  const handleSignOut = async () => {
    setIsLoading(true);
    await logout();
    navigate('/login');
  };

  if (!user) {
    return null;
  }

  const access = checkUserAccess(user);
  const userTypeName = user.user_type || 'unknown';

  if (!access.errorMessage) {
    return null;
  }

  return (
    <div className="access-denied-screen">
      {/* Top brand */}
      <div className="top-brand">
        <img src="/avro-logo-nobg.png" alt="Avro Recycling" className="brand-logo" />
      </div>

      <div className="access-denied-container">
        {/* Simple icon */}
        <div className="error-icon">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 22C12 22 20 18 20 12V5L12 2L4 5V12C4 18 12 22 12 22Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M15 9L9 15M9 9L15 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>

        <h1 className="error-title">Access Denied</h1>
        
        <p className="error-message">
          {access.errorMessage || `This app is only for Pickers. Your account type is ${userTypeName}.`}
        </p>

        <button 
          className="sign-out-btn" 
          onClick={handleSignOut}
          disabled={isLoading}
        >
          {isLoading ? 'Signing Out...' : 'Sign Out'}
        </button>

        <p className="support-text" onClick={() => setShowContactInfo(!showContactInfo)}>
          Need help? <span className="support-link">Contact Support</span>
        </p>

        {showContactInfo && (
          <div className="contact-info">
            <a href="tel:+919910039125" className="contact-link">
              📞 +91 9910039125
            </a>
            <a href="mailto:info@avrorecycling.com" className="contact-link">
              ✉️ info@avrorecycling.com
            </a>
          </div>
        )}
      </div>

      {/* Bottom footer */}
      <div className="bottom-footer">
        <p>© 2026 Avro Recycling. All rights reserved.</p>
      </div>
    </div>
  );
};

export default AccessDenied;
